// components/Sidebar.tsx
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ConfirmModal from "./ConfirmModal";
import logo from "../assets/01pos.webp";

const Sidebar = ({
  navLinks,
  onSignOut,
  modalTexts = {
    title: "Confirm Quit",
    message: "Are you sure you want to quit the app?",
  },
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleQuit = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleConfirmQuit = () => {
    sessionStorage.removeItem("admin_token");
    sessionStorage.removeItem("token");

    if (onSignOut) {
      onSignOut();
    } else {
      navigate("/login");
    }
  };

  return (
    <div className="w-2/12 h-screen flex flex-col border-black border-r">
      <img src={logo} alt="Sidebar Logo" className="w-24 p-2 mt-2" />
      <nav className="flex flex-col gap-4 p-1">
        {navLinks.map((link, index) => (
          <NavLink
            to={link.path}
            end={link.exact}
            key={index}
            className={({ isActive }) =>
              isActive
                ? "flex flex-row bg-gray-500 p-2 rounded-md text-white gap-2 items-center"
                : "flex flex-row hover:bg-gray-300 rounded-md p-2 gap-2 items-center"
            }
          >
            {link.icon}
            <h3 className="hidden lg:block text-lg font-medium">
              {link.label}
            </h3>
          </NavLink>
        ))}
      </nav>

      <div className="mt-auto mb-6 p-2">
        <button onClick={handleQuit} className="flex">
          <ExitToAppIcon className="text-red-500" sx={{ fontSize: 40 }} />
          <h3 className="text-2xl hidden lg:block text-red-500">Sign out</h3>
        </button>

        <ConfirmModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onConfirm={handleConfirmQuit}
          text1={modalTexts.title}
          text2={modalTexts.message}
        />
      </div>
    </div>
  );
};

export default Sidebar;
